import { render, staticRenderFns } from "./BankTransaction.vue?vue&type=template&id=068b2fe8&"
import script from "./BankTransaction.vue?vue&type=script&lang=js&"
export * from "./BankTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports